export default __webpack_public_path__ + "static/media/Apercu-Bold.16a839d2.otf";